import React from 'react';
import Link from 'next/link';
import styles from '../../styles/blog/articleCard.module.scss';

function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function ArticleCard({ article }) {
    if (!article) return null;

    return (
        <Link href={`/blog/${article.slug}`} className={styles.card}>
            <div className={styles.imageWrapper}>
                <img
                    src={article.cover?.url || '/images/blog-placeholder.png'}
                    alt={article.cover?.alternativeText || article.title}
                    className={styles.image}
                />
                {article.category && (
                    <span className={styles.categoryBadge}>{article.category.name}</span>
                )}
            </div>
            <div className={styles.content}>
                <h3 className={styles.title}>{article.title}</h3>
                {article.description && (
                    <p className={styles.excerpt}>{article.description}</p>
                )}
                <div className={styles.meta}>
                    <span>{formatDate(article.publishedAt)}</span>
                    {article.readTime && (
                        <>
                            <span className={styles.dot}></span>
                            <span>{article.readTime} min read</span>
                        </>
                    )}
                </div>
            </div>
        </Link>
    );
}
